<app-dark-bottom-svg></app-dark-bottom-svg>
<div class="container-fluid text-light bg-dark-black">
  <div class="animate-to-top row text-center">
    <div class="col-12 mt-5">
      <h1 class="horizontal-line">
        <span class="bg-dark-black px-3">Services</span>
      </h1>
    </div>
  </div>

  <div class="animate-to-top row mt-5">
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="ui" class="w-100 h-100"></canvas>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="web" class="w-100 h-100"></canvas>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="fullStack" class="w-100 h-100"></canvas>
    </div>
  </div>
</div>
